"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendDownloadPromptEvent = void 0;
var __1 = require("../..");
var DOWNLOAD_PROMPT_VIEW_EVENT_NAME = "app_download_v0";
/**
 * Sends an event that the mobile download prompt was viewed or clicked
 * Event name: "app_download_v0"
 * * @param pageName name of the current page
 * * @param promptAction the type of event, either click or view
 * * @param eventDetails the data for the event. Optional as most pages don't require it
 */
var sendDownloadPromptEvent = function (pageName, promptAction, eventDetails) {
    var _a;
    if (eventDetails)
        (0, __1.sendEvent)(null, null, null, DOWNLOAD_PROMPT_VIEW_EVENT_NAME, eventDetails);
    else {
        var eventInfo = {
            page: (_a = {},
                _a[pageName] = {},
                _a),
            action: promptAction,
            persistent_banner: {},
        };
        (0, __1.sendEvent)(null, null, null, DOWNLOAD_PROMPT_VIEW_EVENT_NAME, eventInfo);
    }
};
exports.sendDownloadPromptEvent = sendDownloadPromptEvent;
